// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
// import VueLazyload from 'vue-lazyload';
import 'intersection-observer';
Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper)
// Vue.use(VueLazyload, {
//     attempt: 1,
//     error: 'https://pic.616pic.com/ys_img/00/05/66/A6XaeFUerS.jpg', // 加载失败时显示的图片
//     loading: 'https://pic.616pic.com/ys_img/00/05/66/A6XaeFUerS.jpg', // 加载时显示的图片
// });

import lazyload from './directives/lazyload';

Vue.directive('lazyload', lazyload);

/* eslint-disable no-new */
new Vue({
    el: '#app',
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js